import { render } from "./hpContact.vue?vue&type=template&id=3bf0527d&scoped=true"
import script from "./hpContact.vue?vue&type=script&lang=js"
export * from "./hpContact.vue?vue&type=script&lang=js"

import "./hpContact.vue?vue&type=style&index=0&id=3bf0527d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf0527d"]])

export default __exports__